exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wallpaper-section {\n  height: 100%;\n  /*background:url(../images/wall.jpg);*/\n  /*background-size:cover;*/\n  background: #eee;\n}\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/views/wallpaper.vue
 ** module id = 41
 ** module chunks = 0
 **/